// import '@/static/css/weui.css'
const weui = require('weui.js')
function install(Vue) {
  //px转rem  已作废 不用手工调用
  function px2rem (){
    var html = document.documentElement;
    var windowWidth = html.clientWidth;
    html.style.fontSize = windowWidth / 7.5 + 'px';
  }
  Vue.prototype.px2rem = function () {
    document.addEventListener('DOMContentLoaded', px2rem, false);
    window.addEventListener('resize', px2rem, false);
  };
  //weui 普通公用的信息提示框
  Vue.prototype.alert = function (msg) {
    return weui.alert(msg);
  };
  Vue.prototype.$weui = weui;
  Vue.prototype.toast = function (msg) {
    return weui.toast(msg,2000);
  };
  //weui 确认信息提示框
  Vue.prototype.confirm = function (title, btn1, btn2, btn1Func, btn2Func) {

    weui.confirm('', {
      title: title,
      buttons: [{
        label: btn1 == '' ? "取消" : btn1,
        type: 'default',
        onClick: btn1Func
      }, {
        label: btn2 == '' ? "确定" : btn2,
        type: 'primary',
        onClick: btn2Func
      }]
    });
  };
  //weui 正在提交提示框
  Vue.prototype.loading = function (msg) {
    return weui.loading('loading', {
      conten: msg || '正在提交',
      className: 'custom-classname'
    });
  };
  //weui 操作成功提示框
  Vue.prototype.success = function (msg) {
    return weui.toast("操作成功", 3000);
  };
  Vue.prototype.topTips = function (msg,tipClass, cb) {
    weui.topTips(msg || '请填写正确的字段', {
      duration: 3000,
      className: tipClass || 'custom-classname',
      callback: function () {
        if (cb) {
          cb();
        }
      }
    });
  };
  //计算两个日期之间的差值
  Vue.prototype.getDiffDays = function (startDate, endDate) {
    if (startDate == '' || endDate == '') {
      return "0";
    } else {
      var startTime = new Date(Date.parse(startDate.replace(/-/g, "/"))).getTime();
      var endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
      var dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24);
      if (isNaN(dates)) {
        dates = "0";
      }
      return dates;
    }
  }
  //获取用户终端类型的标识
  Vue.prototype.browser = {
    versions: function () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq", //是否QQ
        ios9: app.indexOf('OS 9_') > -1, //是否是IOS9
        ios10: app.indexOf('OS 10_') > -1 //是否是IOS10
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  //返回中文的星期
  Date.prototype.weekDay = function (timeStamp) {
    let date = new Date(timeStamp);
    let weekDay = date.getDay();
    let result = '';
    let prefix = '星期';
    switch (weekDay) {
      case 0:
        result = '日';
        break;
      case 1:
        result = '一';
        break;
      case 2:
        result = '二';
        break;
      case 3:
        result = '三';
        break;
      case 4:
        result = '四';
        break;
      case 5:
        result = '五';
        break;
      case 6:
        result = '六';
        break;
    }
    return prefix + result;
  };
  /*时间格式化 公用方法*/
  Date.prototype.Format = function (fmt) { //
    var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
  Date.prototype.comparTime = function (in_date) {
    var timestamp = Date.parse(new Date());
    var d_value = Math.ceil((timestamp - in_date) / 1000);
    var d_html = "";
    if (d_value < 60) {
      d_html = "1分钟内";
    } else if (d_value > 60 && d_value < 3600) {
      d_html = parseInt(d_value / 60) + "分钟前";
    } else if (d_value > 3600 && d_value < 86400) {
      d_html = parseInt(d_value / 3600) + "小时前";
    } else if (d_value > 86400 && d_value < 604800) {
      d_html = parseInt(d_value / 86400) + "天前";
    } else if (d_value > 604800 && d_value < 2419200) {
      d_html = parseInt(d_value / 604800) + "周前";
    } else if (d_value > 2419200 && d_value < 31536000) {
      d_html = parseInt(d_value / 2419200) + "月前";
    } else if (d_value > 31536000) {
      d_html = parseInt(d_value / 31536000) + "年前";
    }
    return d_html;
  };
}
export default install;



// WEBPACK FOOTER //
// ./src/plugin/mVueUtils.js